import { useNavigate } from "react-router-dom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

export default function renderStakeCheckingInsufficientFundsAlert(modalContext) {
  const { updateModalComponent, setPreventCloseOnBackdropClick, setModalVariant, setModalTitle, setModalClassName } =
    modalContext;

  updateModalComponent(StakeCheckingInsufficientFundsAlert);
  setModalVariant(modalVariants.flexDialog);
  setPreventCloseOnBackdropClick(true);
  setModalClassName("no-full-screen align-title-left");
  setModalTitle("⚠️ We Couldn't Process Your $10 Stake Saver Membership Fee");
}

const StakeCheckingInsufficientFundsAlert = () => {
  const { onModalClose } = useModalContext();

  const navigate = useNavigate();

  const addFunds = () => {
    navigate("/banking/add-cash");
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content">
        <p className="text-base-regular color--mist mb-3">
          There weren’t enough funds in your account to cover the fee.
        </p>
        <p className="text-base-regular color--mist mb-3">
          To keep your Stake Checking account open,{" "}
          <span className="text-base-medium">please add funds as soon as possible</span>.
        </p>
        <p className="text-base-regular color--mist mb-0">
          If the balance remains at $0, your account may be closed after 60 days of inactivity.
        </p>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={addFunds}>Add Funds</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={onModalClose}>
          Close
        </PrimaryButton>
      </div>
    </>
  );
};
